<template>
  <!-- 流程设置弹框-分支流程 -->
  <el-dialog class="dialog-process-setting" :visible.sync="dialogVisible" :fullscreen="true" :show-close="false" @close="handleClose">
    <div class="header">
      <div class="header-title">
        <i class="el-icon-arrow-left" @click="goBack"></i>
        <span>{{ headTitle }}</span>
      </div>
      <el-steps class="process-steps" :active="active">
        <el-step title="规则设置"></el-step>
        <el-step title="审批表单"></el-step>
        <el-step title="审批流程"></el-step>
        <el-step title="发布审批"></el-step>
      </el-steps>
      <div class="icons">
        <!-- class="header-icon left" :class="{ active: active !== 1 }" -->
        <span @click="prev" style="margin-right: 20px">
          <img v-if="active == 1" src="../../../assets/images/icon_left@2x.png" alt="">
          <img v-else src="../../../assets/images/icon_left_press@2x.png" alt="">
          <!-- <svg-icon icon-class="left" class="header-icon"/> -->
        </span>
        <!--  class="header-icon right ml-20" :class="{ disable: active === 4 }" -->
        <span @click="next">
          <img v-if="active == 4" src="../../../assets/images/icon_right@2x.png" alt="">
          <img v-else src="../../../assets/images/icon_right_press@2x.png" alt="">
          <!-- <svg-icon icon-class="right" class="header-icon right"/> -->
        </span>
      </div>
    </div>
    <div class="wrap">
      <!-- 规则设置 -->
      <el-form class="g-form-grid step1" ref="form" :model="form" :rules="rules" label-width="86px" v-if="active === 1">
        <el-form-item label="审批名称：" prop="workflowName">
          <el-input v-model="form.workflowName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="图标：">
          <div class="images">
            <img :src="iconUrl || ''" alt v-if="iconUrl" />
            <svg-icon icon-class="add" v-if="!iconUrl" />
            <cmp-upload class="upload-opcity" :accept="`image/*`" :businessType="`project`" :callEveryFun="uploadCallback" :conacat="false"></cmp-upload>
          </div>
        </el-form-item>
        <el-form-item label="所属分类：">
          <el-radio-group v-model="form.typeId">
            <el-radio v-for="item in typeArr" :key="item.typeId" :label="item.typeId">{{ item.typeName }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="next('save')">保存</el-button>
        </el-form-item>
      </el-form>

      <!-- 审批表单 -->
      <div class="step-two" v-if="active === 2">
        <el-form class="g-form-grid step2" ref="form" label-width="110px">
          <cmpFormItem v-for="(item, index) in renderData.fields" :key="index" :itemData="item" :form="form" :isDisable="true"></cmpFormItem>

          <cmpFormList ref="cmpFormList" :detailObj="renderData.detail" :form="form" :isDisable="true" v-if="renderData.detail && renderData.detail.length"></cmpFormList>
        </el-form>
      </div>

      <!-- 审批流程 -->
      <div class="step-three" v-if="active === 3">
        <div class="fd-nav-content">
          <!-- <span
            @click="saveSet"
            style="font-size:30px;color:blue;position:relative;z-index:4;"
            >发布</span
          > -->
          <section class="dingflow-design">
            <div class="box-scale" id="box-scale">
              <nodeWrap :nodeConfig.sync="nodeConfig" :flowPermission.sync="flowPermission" :isTried.sync="isTried" :directorMaxLevel="directorMaxLevel" :tableId="tableId" :tableName="tableName"></nodeWrap>
              <div class="end-node">
                <div class="end-node-circle"></div>
                <div class="end-node-text">流程结束</div>
              </div>
            </div>
          </section>
        </div>

        <!-- 版本一 -->
        <!-- <div class="hide">
          <div class="flex">
            <el-button class="start">开始</el-button>
          </div>
          <div class="arrow">
            <div class="arrow-body"></div>
          </div>
          <div class="flex">
            <svg-icon icon-class="append" @click.native="addDom('first')"/>
          </div>
          <div class="arrow">
            <div class="arrow-body"></div>
          </div>
          <div v-for="(item,index) in panelData.approver" :key="index">
            <div class="flex">
              <el-card class="box-card" @click.native.stop="addApprove(item, index)">
                <div slot="header" class="clearfix">
                  <span>审批节点</span>
                  <span @click.stop="remove(index)">
                    <svg-icon icon-class="close" style="font-size: 14px;float: right"/>
                  </span>
                </div>
                <div class="text item">{{item.name}}</div>
              </el-card>
            </div>
            <div class="arrow">
              <div class="arrow-body"></div>
            </div>
            <div class="flex">
              <svg-icon icon-class="append" @click.native="addDom('after',index)"/>
            </div>
            <div class="arrow">
              <div class="arrow-body"></div>
            </div>
          </div>

          <div class="arrow">
            <div class="arrow-body"></div>
          </div>
          <div class="flex">
            <el-button type="primary">结束</el-button>
          </div>
          <template v-if="!ccPerson">
            <div class="flex cc">
              <svg-icon icon-class="append" @click.native="ccPerson=true"/>&nbsp;&nbsp;添加抄送人
            </div>
          </template>
          <template v-if="ccPerson">
            <div class="arrow">
              <div class="arrow-body"></div>
            </div>
            <div class="flex cc-person">
              <el-card class="box-card" @click.native.stop="addCopy">
                <div slot="header" class="clearfix">
                  <span>抄送人</span>
                </div>
                <div class="text item" v-if="panelData.copyto.options.length">
                  <span v-for="(item, index) in panelData.copyto.options" :key="index">
                    <i>{{index > 0 ? ','+ item.name : item.name}}</i>
                  </span>
                </div>
                <div class="text item" v-else>未设置抄送人</div>
              </el-card>
            </div>
          </template>
        </div>-->
      </div>

      <!-- 发布审批 -->
      <div class="step-four" v-if="active === 4">
        <div class="images">
          <img src="~@images/no-data.svg" alt />
        </div>
        <h2>您正在发布审批流程...</h2>
        <!-- <div class="time">上次发布：2019年02月16日 17:56</div> -->
        <div class="time">上次发布：{{ lastPublishTime }}</div>
        <div class="button">
          <el-button type="primary" @click="saveSet" :loading="loadingSave">确认发布</el-button>
          <!-- 版本1 -->
          <!-- <el-button type="primary" @click="publish" :loading="loadingSave"
            >确认发布</el-button
          > -->
          <el-button @click="cancle">放弃修改</el-button>
        </div>
        <div class="bom-msg time">
          当审批流程有修改时，发布后正在审批中的申请不会受到影响
        </div>
      </div>

      <approveNodePanel ref="approveNodePanel" @getPanelData="getPanelData"></approveNodePanel>
    </div>
  </el-dialog>
</template>

<script>
// import nodeWrap from '@cmp/workflow/nodeWrap'

import cmpUpload from '@cmp/my-upload/index'
import cmpFormItem from '@cmp/form/item'
import cmpFormList from '@cmp/form/list'
import approveNodePanel from './approve-node-panel' // 审批面板
export default {
  components: {
    // nodeWrap,
    cmpUpload,
    cmpFormItem,
    cmpFormList,
    approveNodePanel
  },
  data() {
    return {
      loadingSave: false,
      defaultImg: this.$store.state.app.defaultImg, // 表格默认图片
      dialogVisible: false,
      headTitle: '',
      configId: '', // 配置id
      formId: '', // 审批表单id
      form: {
        workflowName: '',
        typeId: '', // 所属分类
        attachmentId: ''
      },
      typeArr: [], // 所属分类选项
      iconUrl: '', //图标路径
      rules: {},
      active: 1, // 当前选中tab
      ccPerson: true, // 显示抄送人
      renderData: [],
      panelData: {
        approver: [], // 审批
        // 抄送人
        copyto: {
          options: []
        }
      },
      lastPublishTime: '', // 上次发布时间

      isTried: false,
      processConfig: {},
      nodeConfig: {},
      workFlowDef: {},
      flowPermission: [],
      directorMaxLevel: 0,
      tableId: '',
      tableName: ''
    }
  },
  methods: {
    init(id) {
      this.active = 1
      // this.active = 1
      this.configId = id

      // 重置
      this.form = {
        workflowName: '',
        typeId: '', // 所属分类
        attachmentId: ''
      }
      this.panelData = {
        approver: [], // 审批
        // 抄送
        copyto: {
          options: []
        }
      }
      switch (this.active) {
        case 1:
          this.getDataStep1()
          break
        case 2:
          this.getDataStep2()
          break
        case 3:
          this.getDataStep3()
          break
      }
      this.dialogVisible = true
    },
    saveSet() {
      // this.isTried = true
      // this.tipList = []
      // this.reErr(this.nodeConfig)
      // if (this.tipList.length != 0) {
      //   this.tipVisible = true

      //   this.$message.error('请设置红框处节点内容')
      //   return
      // }
      this.processConfig.flowPermission = this.flowPermission
      console.log('表单', this.processConfig)
      console.log(JSON.stringify(this.processConfig))

      this.loadingSave = true
      this.$http
        .post('/workflowConfig/save', {
          configId: this.configId,
          workflowContent: JSON.stringify(this.processConfig)
        })
        .then((res) => {
          this.loadingSave = false
          if (res.success) {
            this.$message.success('流程配置发布成功')
            this.dialogVisible = false
            this.$emit('refresh')
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(() => {
          this.loadingSave = false
        })
      // this.$axios.post("", this.processConfig).then(res => {
      //     if (res.code == 200) {
      //         this.$message.success("设置成功");
      //         setTimeout(function () {
      //             window.location.href = ""
      //         }, 200)
      //     }
      // })
    },
    reErr(data) {
      if (data.childNode) {
        if (data.childNode.type == 1) {
          //1审批人
          if (data.childNode.error) {
            this.tipList.push({ name: data.childNode.nodeName, type: '审核人' })
          }
          this.reErr(data.childNode)
        } else if (data.childNode.type == 2) {
          // 2抄送人
          if (data.childNode.error) {
            this.tipList.push({ name: data.childNode.nodeName, type: '抄送人' })
          }
          this.reErr(data.childNode)
        } else if (data.childNode.type == 3) {
          // 3条件
          this.reErr(data.childNode.childNode)
        } else if (data.childNode.type == 4) {
          // 4路由-添加条件按钮
          this.reErr(data.childNode)
          for (var i = 0; i < data.childNode.conditionNodes.length; i++) {
            if (data.childNode.conditionNodes[i].error) {
              this.tipList.push({
                name: data.childNode.conditionNodes[i].nodeName,
                type: '条件'
              })
            }
            this.reErr(data.childNode.conditionNodes[i])
          }
        }
      } else {
        data.childNode = null
      }
    },
    goBack() {
      this.dialogVisible = false
      this.$emit('refresh')
    },
    getDataStep1() {
      this.$http
        .get('/workflowConfig/find', {
          id: this.configId
        })
        .then((res) => {
          if (res.success) {
            let data = res.result
            this.headTitle = data.workflowName
            this.formId = data.formId
            this.iconUrl = data.image
            this.typeArr = data.options
            this.form.workflowName = data.workflowName
            this.form.typeId = data.typeId
            this.lastPublishTime = data.lastUpdate
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getDataStep2() {
      this.$http
        .get('/workflowForm/find', {
          id: this.formId
        })
        .then((res) => {
          this.renderData = res.result.formContent

          // 复选框的情况
          this.renderData.fields.forEach(item => {
            if (item.type === 'checkbox') {
              this.$nextTick(() => {
                this.$set(this.form, item.name, [])
              })
            }
          })
          console.log(this.form)
          // todo详情中复选框的情况
          // this.renderData.detail.forEach(item => {
          //   if(item.type === 'checkbox') {
          //     this.$nextTick(() => {
          //       this.$set(this.form, item.name, [])
          //     })
          //   }
          // })
        })
    },
    // 审批流程查询
    getDataStep3() {
      this.$http
        // .get(`../${process.env.BASE_URL}data.1.json`, {
        // .get(`../${process.env.BASE_URL}http.json`, {
        .get('/workflowConfig/detail', {
          id: this.configId
        })
        .then((res) => {
          // if (res.success) {
          // 版本2
          // res.result.type = 0
          this.processConfig = res.result
          this.nodeConfig = this.processConfig.nodeConfig
          this.flowPermission = this.processConfig.flowPermission
          this.directorMaxLevel = this.processConfig.directorMaxLevel
          this.workFlowDef = this.processConfig.workFlowDef
          this.tableId = this.processConfig.tableId
          this.tableName = this.processConfig.workflowName
          // 版本1
          // let data = res.result
          // this.panelData.approver = data.approver
          // this.panelData.copyto = data.copyto
          // } else {
          //   this.$message.error(res.message)
          // }
        })
    },
    uploadCallback(item) {
      this.form.attachmentId = item.attId
      this.iconUrl = item.attPath
    },
    // 获取面板数据 审批人、抄送人
    getPanelData(data, type) {
      if (type === 'approve') {
        this.$set(
          this.panelData.approver,
          data.approveObj.index,
          data.approveObj.item
        )
      } else if (type === 'copy') {
        this.panelData.copyto = data.copyto
      }
    },
    // 保存第一步规则设置
    saveInfo() {
      this.$http
        .post('/workflowConfig/save', {
          configId: this.configId,
          workflowName: this.form.workflowName,
          attachmentId: this.form.attachmentId,
          typeId: this.form.typeId
        })
        .then((res) => {
          if (res.success) {
            this.$message.success('规则设置成功')
            this.headTitle = this.form.workflowName
            if (this.active++ > 3) this.active = 1
            this.getDataStep2()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 添加审批人
    addApprove(item, index) {
      this.$refs.approveNodePanel.init('approve', item, index)
    },
    // 添加抄送人
    addCopy() {
      this.$refs.approveNodePanel.init('copy', this.panelData)
    },
    next(type) {
      if (type === 'save') {
        this.saveInfo()
        return
      } else if (this.active === 1) {
        this.getDataStep2()
      } else if (this.active === 2) {
        this.getDataStep3()
      } else if (this.active === 3) {
        this.isTried = true
        this.tipList = []
        this.reErr(this.nodeConfig)
        if (this.tipList.length != 0) {
          this.tipVisible = true

          console.log('表单', this.processConfig)
          console.log(JSON.stringify(this.processConfig))
          this.$message.error('请设置红框处节点内容')
          return
        }
        // 版本1 是否存在未设置的审批节点
        // let obj = this.panelData.approver.find(item => {
        //   return !item.type
        // })
        // if (!this.panelData.approver.length || (obj && !obj.type)) {
        //   this.$message.warning('请设置审批节点')
        //   return
        // }
      }
      if (this.active++ > 3) this.active = 4
    },
    prev() {
      if (this.active-- < 2) this.active = 1
    },
    // 添加节点
    addDom(dir, index) {
      const newChild = { name: '未设置审批人' }
      if (!this.panelData.approver) {
        this.$set(this.panelData.approver, 'child', [])
      }
      if (!index && index !== 0) {
        this.panelData.approver.unshift(newChild)
      } else {
        this.panelData.approver.splice(index + 1, 0, newChild)
      }
    },
    remove(index) {
      this.panelData.approver.splice(index, 1)
    },
    // 发布
    publish() {
      console.log('this.processConfig:', this.processConfig)
      return

      this.loadingSave = true
      this.$http
        .post('/workflowConfig/save', {
          configId: this.configId,
          workflowContent: JSON.stringify(this.panelData)
        })
        .then((res) => {
          this.loadingSave = false
          if (res.success) {
            this.$message.success('流程配置发布成功')
            this.dialogVisible = false
            this.$emit('refresh')
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(() => {
          this.loadingSave = false
        })
    },
    cancle() {
      this.$common.confirm(
        {
          title: '放弃修改',
          content: '数据不会保存，确认放弃修改吗？'
        },
        () => {
          this.dialogVisible = false
          this.$emit('refresh')
        }
      )
    },
    handleClose() {
      this.$refs.approveNodePanel.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100%;
}
.fd-nav-content {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 30px;
  .dingflow-design {
    width: 100%;
    background-color: #f5f5f7;
    overflow: auto;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    .box-scale {
      transform: scale(1);
      display: inline-block;
      position: relative;
      width: 100%;
      padding: 54.5px 0;
      -webkit-box-align: start;
      -ms-flex-align: start;
      align-items: flex-start;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      min-width: -webkit-min-content;
      min-width: -moz-min-content;
      min-width: min-content;
      background-color: #f5f5f7;
      -webkit-transform-origin: 0 0 0;
      transform-origin: 0 0 0;
    }
    .end-node {
      border-radius: 50%;
      font-size: 14px;
      color: rgba(25, 31, 37, 0.4);
      text-align: left;
      .end-node-circle {
        width: 10px;
        height: 10px;
        margin: auto;
        border-radius: 50%;
        background: #dbdcdc;
      }

      .end-node-text {
        margin-top: 5px;
        text-align: center;
      }
    }
  }
}
.dialog-process-setting {
  overflow-y: hidden;
  /deep/ .el-dialog {
    min-width: 1400px;
    overflow-x: auto;
    overflow-y: hidden;
    background: $color2;
    padding: 0;
    .el-dialog__header {
      padding-bottom: 0;
    }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #fff;
      padding: 15px 0;
      .header-title {
        font-weight: bold;
        color: rgba(87, 89, 98, 1);
        font-size: 18px;
        margin-left: 20px;
        flex: 2;
        span {
          margin-left: 10px;
        }
      }
      .el-icon-arrow-left {
        color: $primary;
        font-weight: bold;
        cursor: pointer;
      }
      .el-steps {
        background: #fff;
        flex: 4;
        .el-step__line {
          margin-left: 100px;
          margin-right: 150px;
        }
        .el-step__main {
          position: absolute;
          bottom: 0;
          left: 30px;
          .el-step__title.is-wait {
            white-space: nowrap;
          }
          .el-step__title.is-process {
            white-space: nowrap;
          }
          .el-step__title.is-finish {
            white-space: nowrap;
          }
        }
      }
      .icons {
        flex: 2;
        text-align: right;
        margin-left: 100px;
        img{
          width: 30px;
        }
        span{
          cursor: pointer;
        }
        .header-icon {
          display: inline-block;
          // width: 30px;
          // height: 30px;
          cursor: pointer;
          border-radius: 50%;
          &.left {
            width: 30px;
            height: 30px;
            object-fit: cover;
            background: url(~@images/icon_left@2x.png) center center no-repeat;
            &.active {
              background: url(~@images/icon_left_press@2x.png) center center
                no-repeat;
            }
          }
          &.right {
            background: url(~@images/icon_right_press@2x.png) center center
              no-repeat;
            &.disable {
              background: url(~@images/icon_right@2x.png) center center
                no-repeat;
              opacity: 0.5;
            }
          }
        }
      }
    }
    .wrap {
      height: calc(100vh - 63px);
      overflow-y: auto;
      .g-form-grid.step1,
      .g-form-grid.step2 {
        background: #fff;
        margin: 30px 200px;
        .images {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100px;
          height: 100px;
          background: #fff;
          border: solid 1px $border;
          border-radius: 4px;
          cursor: pointer;
          img {
            // width: 100%;
            max-height: 30px;
            object-fit: cover;
          }
        }
      }

      .g-form-grid.step1 {
        padding: 80px 200px 150px 200px;
        .el-form-item {
          margin-bottom: 50px;
        }
      }
      .g-form-grid.step2 {
        padding: 30px 180px;
      }

      .upload-opcity {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        line-height: 40px;
        z-index: 999;
        opacity: 0;
        .g-inline-block {
          display: block;
          height: 100%;
          .el-upload {
            display: block;
            height: 100%;
          }
        }
      }

      .step-four {
        margin: 30px 200px;
        background: #fff;
        height: 688px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        .images {
          height: 229px;
          width: 232px;
        }
        h2 {
          margin: 50px 0 10px 0;
        }
        .button {
          margin-top: 30px;
        }
        .bom-msg {
          position: absolute;
          bottom: 30px;
        }
        .time {
          color: #9699a2;
        }
      }
      .step-three {
        margin: 30px auto;
        padding-bottom: 50px;
        width: 700px;
        .flex {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          .start {
            border-radius: 4px;
          }
          .svg-icon {
            font-size: 20px;
            cursor: pointer;
          }
          .el-card {
            cursor: pointer;
            .el-card__header {
              padding: 10px;
              background: $primary;
              color: #fff;
            }
          }

          .text {
            padding: 15px 10px;
          }

          .item {
            margin-bottom: 18px;
          }
        }
        .cc-person {
          .el-card {
            .el-card__header {
              padding: 10px;
              background: rgba(52, 191, 163, 1);
              color: #fff;
            }
          }
        }
        .cc {
          margin: 30px 175px;
          cursor: pointer;
        }

        .flex > div {
          width: 25%;
        }

        .arrow {
          margin: 0 10px 0;
        }

        .arrow-body {
          width: 1px;
          height: 50px;
          background: $primary;
          margin: 0 auto;
        }
      }
    }
  }

  /deep/.process-steps {
    .el-step {
      margin-right: 10px !important;
      .el-step__icon {
        top: -1px;
        // width: 20px;
        // height: 20px;
        border: none;
        background: $border;
        color: $color6;
        font-size: 16px;
      }
      .el-step__line {
        height: 1px;
      }
      .el-step__line-inner {
        border-top: 0;
      }
      .el-step__title {
        color: $color5;
        font-weight: bold;
        &.is-finish {
          color: $primary;
        }
      }

      .el-step__head.is-finish {
        .el-step__icon {
          background: $primary;
          color: #fff;
        }
      }
    }
  }
}
</style>
